// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"552":"554c0545","568":"70e6c1e4","740":"8dbbee60"}[chunkId] + ".css";
};